var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryShred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "crm-cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1792v1080h-1792z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "crm-cp2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m740 798.12c0-2.35 1.89-4.27 4.21-4.27 2.03 0 3.73 1.47 4.12 3.42h7.18c0.39-1.95 2.09-3.42 4.12-3.42 2.03 0 3.73 1.47 4.12 3.42h7.18c0.39-1.95 2.09-3.42 4.12-3.42 2.32 0 4.21 1.92 4.21 4.27 0 2.36-1.89 4.27-4.21 4.27-2.03 0-3.73-1.47-4.12-3.42h-7.18c-0.39 1.95-2.09 3.42-4.12 3.42-2.03 0-3.73-1.47-4.12-3.42h-7.18c-0.39 1.95-2.09 3.42-4.12 3.42-2.32 0-4.21-1.91-4.21-4.27zm17.26-0.85q-0.15 0.4-0.15 0.85 0 0.45 0.15 0.85c0.35 1 1.27 1.71 2.37 1.71 1.1 0 2.02-0.71 2.37-1.71q0.15-0.4 0.16-0.85-0.01-0.45-0.16-0.85c-0.35-0.99-1.27-1.71-2.37-1.71-1.1 0-2.02 0.72-2.37 1.71zm15.42 0q-0.15 0.4-0.15 0.85 0 0.45 0.15 0.85c0.35 1 1.28 1.71 2.37 1.71 1.39 0 2.53-1.15 2.53-2.56 0-1.41-1.14-2.56-2.53-2.56-1.09 0-2.02 0.72-2.37 1.71zm-31 0.85c0 1.41 1.14 2.56 2.53 2.56 1.1 0 2.02-0.71 2.37-1.71q0.15-0.4 0.15-0.85 0-0.45-0.15-0.85c-0.35-0.99-1.27-1.71-2.37-1.71-1.39 0-2.53 1.15-2.53 2.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "crm-cp3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m740 814.4c0-2.35 1.89-4.27 4.21-4.27 2.03 0 3.73 1.47 4.12 3.42h7.18c0.39-1.95 2.09-3.42 4.12-3.42 2.03 0 3.73 1.47 4.12 3.42h7.18c0.39-1.95 2.09-3.42 4.12-3.42 2.32 0 4.21 1.92 4.21 4.27 0 2.35-1.89 4.27-4.21 4.27-2.03 0-3.73-1.47-4.12-3.42h-7.18c-0.39 1.95-2.09 3.42-4.12 3.42-2.03 0-3.73-1.47-4.12-3.42h-7.18c-0.39 1.95-2.09 3.42-4.12 3.42-2.32 0-4.21-1.92-4.21-4.27zm17.26-0.85q-0.15 0.4-0.15 0.85 0 0.45 0.15 0.85c0.35 0.99 1.27 1.71 2.37 1.71 1.1 0 2.02-0.72 2.37-1.71q0.15-0.4 0.16-0.85-0.01-0.45-0.16-0.85c-0.35-1-1.27-1.71-2.37-1.71-1.1 0-2.02 0.71-2.37 1.71zm15.42 0q-0.15 0.4-0.15 0.85 0 0.45 0.15 0.85c0.35 0.99 1.28 1.71 2.37 1.71 1.39 0 2.53-1.15 2.53-2.56 0-1.41-1.14-2.56-2.53-2.56-1.09 0-2.02 0.71-2.37 1.71zm-31 0.85c0 1.41 1.14 2.56 2.53 2.56 1.1 0 2.02-0.72 2.37-1.71q0.15-0.4 0.15-0.85 0-0.45-0.15-0.85c-0.35-1-1.27-1.71-2.37-1.71-1.39 0-2.53 1.15-2.53 2.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "crm-cp4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m740 830.68c0-2.36 1.89-4.27 4.21-4.27 2.03 0 3.73 1.47 4.12 3.41h7.18c0.39-1.94 2.09-3.41 4.12-3.41 2.03 0 3.73 1.47 4.12 3.41h7.18c0.39-1.94 2.09-3.41 4.12-3.41 2.32 0 4.21 1.91 4.21 4.27 0 2.35-1.89 4.26-4.21 4.26-2.03 0-3.73-1.46-4.12-3.41h-7.18c-0.39 1.95-2.09 3.41-4.12 3.41-2.03 0-3.73-1.46-4.12-3.41h-7.18c-0.39 1.95-2.09 3.41-4.12 3.41-2.32 0-4.21-1.91-4.21-4.26zm17.26-0.86q-0.15 0.41-0.15 0.86 0 0.45 0.15 0.85c0.35 0.99 1.27 1.71 2.37 1.71 1.1 0 2.02-0.72 2.37-1.71q0.15-0.4 0.16-0.85-0.01-0.45-0.16-0.86c-0.35-0.99-1.27-1.7-2.37-1.7-1.1 0-2.02 0.71-2.37 1.7zm15.42 0q-0.15 0.41-0.15 0.86 0 0.45 0.15 0.85c0.35 0.99 1.28 1.71 2.37 1.71 1.39 0 2.53-1.15 2.53-2.56 0-1.41-1.14-2.56-2.53-2.56-1.09 0-2.02 0.71-2.37 1.7zm-31 0.86c0 1.41 1.14 2.56 2.53 2.56 1.1 0 2.02-0.72 2.37-1.71q0.15-0.4 0.15-0.85 0-0.45-0.15-0.86c-0.35-0.99-1.27-1.7-2.37-1.7-1.39 0-2.53 1.15-2.53 2.56z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.crm_s0 { fill: #4e5766 } \n\t\t.crm_s1 { fill: #533ffb } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crm-icon-workspace-task-create-folder",
    clipPath: "url(#crm-cp1)",
    transform: "translate(-740 -794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 7779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6458",
    clipPath: "url(#crm-cp2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "crm-Rectangle 6951",
    className: "crm_s0",
    d: "m731.5 785.4h56.3v26.3h-56.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6458",
    clipPath: "url(#crm-cp3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "crm-Rectangle 6951",
    className: "crm_s0",
    d: "m731.5 801.3h56.3v26.2h-56.3z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6458",
    clipPath: "url(#crm-cp4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crm-Group 6456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "crm-Rectangle 6951",
    className: "crm_s0",
    d: "m731.5 817.1h56.3v26.3h-56.3z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "crm-Ellipse 11",
    className: "crm_s1",
    d: "m772.1 805.3c-0.7 0-1.3-0.6-1.3-1.3 0-0.7 0.6-1.3 1.3-1.3 0.7 0 1.3 0.6 1.3 1.3 0 0.7-0.6 1.3-1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crm-Ellipse 12",
    className: "crm_s1",
    d: "m768.6 808.8c-0.7 0-1.3-0.8-1.3-1.8 0-0.9 0.6-1.7 1.3-1.7 0.7 0 1.3 0.8 1.3 1.7 0 1-0.6 1.8-1.3 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crm-Ellipse 18",
    className: "crm_s1",
    d: "m753.9 827.8c-0.8 0-1.3-0.7-1.3-1.7 0-1 0.5-1.7 1.3-1.7 0.7 0 1.3 0.7 1.3 1.7 0 1-0.6 1.7-1.3 1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crm-Ellipse 41",
    className: "crm_s1",
    d: "m759.5 823.5c-1 0-1.7-0.6-1.7-1.3 0-0.7 0.7-1.3 1.7-1.3 1 0 1.7 0.6 1.7 1.3 0 0.7-0.7 1.3-1.7 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crm-Ellipse 39",
    className: "crm_s1",
    d: "m751.3 823.5c-0.8 0-1.3-0.6-1.3-1.3 0-0.7 0.5-1.3 1.3-1.3 0.7 0 1.3 0.6 1.3 1.3 0 0.7-0.6 1.3-1.3 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crm-Ellipse 40",
    className: "crm_s1",
    d: "m748.2 820.9c-0.9 0-1.7-0.6-1.7-1.3 0-0.7 0.8-1.3 1.7-1.3 1 0 1.8 0.6 1.8 1.3 0 0.7-0.8 1.3-1.8 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "crm-Ellipse 42",
    className: "crm_s1",
    d: "m765.6 811.4c-1 0-1.8-0.6-1.8-1.3 0-0.8 0.8-1.3 1.8-1.3 0.9 0 1.7 0.5 1.7 1.3 0 0.7-0.8 1.3-1.7 1.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryShred);
export default __webpack_public_path__ + "static/media/category-shred.220347d88a0e669bf1a9e3ce24d3ed60.svg";
export { ForwardRef as ReactComponent };